export default __webpack_public_path__ + "static/media/ic_messenger_b.b32342ba.svg";